import { createApi } from '@reduxjs/toolkit/query/react';
import { apiBaseQuery } from 'src/services/apiClient';

export const CONTENT_ASSIGNMENT_API_REDUCER_PATH = 'contentAssignmentApi';

// Define a service using a base URL and expected endpoints
export const contentAssignmentApi = createApi({
    reducerPath: CONTENT_ASSIGNMENT_API_REDUCER_PATH,
    baseQuery: apiBaseQuery(),
    tagTypes: ['ContentAssignedToRole'],
    endpoints: builder => ({
        getContentForDomainOrCategory: builder.query({
            query: ({ appId, domainId, categoryId, queryOptions }) => {
                let queryStr = '';
                if (queryOptions.filter) {
                    queryStr += `filter=${queryOptions.filter}`;
                }
                if (queryOptions.limit) {
                    queryStr += `&limit=${queryOptions.limit}`;
                }
                if (queryOptions.cursor) {
                    queryStr += `&cursor=${queryOptions.cursor}`;
                }
                if (categoryId) {
                    queryStr += `&category_ids=${categoryId}`;
                }

                let url = `/iambff/v1/content-assignments/connected-apps/${appId}/domains/${domainId}/contents?${queryStr}`;
                return {
                    url,
                    method: 'GET',
                };
            },
        }),
        getAllDomainsListWithCategories: builder.query({
            query: ({ appId }) => ({
                url: `/iambff/v1/connected-apps/${appId}/content-metadata/domains`,
                method: 'GET',
            }),
            transformResponse: response => {
                return response?.domains || [];
            },
        }),
        saveOrUpdateContentAssignment: builder.mutation({
            query: ({ appId, roleId, payload }) => ({
                url: `/iambff/v1/content-assignments/connected-apps/${appId}/role-content-assignments/${roleId}`,
                method: 'PUT',
                data: payload,
            }),
            invalidatesTags: ['ContentAssignedToRole'],
        }),
        getContentAssignedToRole: builder.query({
            query: ({ appId, roleId, domainId, categoryId }) => {
                let url = `/iambff/v1/content-assignments/connected-apps/${appId}/role-content-assignments/${roleId}`;
                const query = {
                    include_global_contents: false,
                };
                if (domainId) {
                    query.domain_id = domainId;
                }
                if (categoryId) {
                    query.category_id = categoryId;
                }
                const queryStr = new URLSearchParams(query);
                return {
                    url: `${url}?${queryStr.toString()}`,
                    method: 'GET',
                };
            },
            providesTags: ['ContentAssignedToRole'],
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetContentForDomainOrCategoryQuery,
    useGetAllDomainsListWithCategoriesQuery,
    useSaveOrUpdateContentAssignmentMutation,
    useGetContentAssignedToRoleQuery,
} = contentAssignmentApi;
